import { render, staticRenderFns } from "./StudentsTranslateModal.vue?vue&type=template&id=0fb0d099&"
import script from "./StudentsTranslateModal.vue?vue&type=script&lang=js&"
export * from "./StudentsTranslateModal.vue?vue&type=script&lang=js&"
import style0 from "./StudentsTranslateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports